module.exports = __webpack_public_path__ + "static/img_4927-e710fd0e06359cb70c6621570ed64ded.webp";